import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=35c8e81a&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=js&"
export * from "./submitBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8e81a",
  null
  
)

export default component.exports